import React, { useCallback } from "react";

import { SubMenuType } from "antd/es/menu/hooks/useItems";

import { Dropdown } from "@mapmycustomers/ui";

import RoundButton from "../RoundButton";

interface SubMenuActionButtonProps {
  action: SubMenuType;
  invisible?: boolean;
}

const SubMenuActionButton = ({ action, invisible, ...props }: SubMenuActionButtonProps) => {
  const getParentElement = useCallback((trigger: HTMLElement) => trigger.parentElement!, []);

  return (
    <div tabIndex={invisible ? -1 : undefined} {...props}>
      <Dropdown
        disabled={action.disabled}
        getPopupContainer={getParentElement}
        menu={{ items: action.children }}
      >
        <RoundButton
          data-item-id={action.key}
          hasMenu
          leftIcon={action.icon}
          tabIndex={invisible ? -1 : undefined}
        >
          {action.label}
        </RoundButton>
      </Dropdown>
    </div>
  );
};

export default SubMenuActionButton;
